"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  chooseHowYouWantToPayForIt: 'Choose how you want to pay for it:',
  congratulations: 'Congratulations!',
  pointsCount: '{0} P',
  youHaveLoyaltyPointsThatYouCanUseOnThisProduct: 'You have loyalty points that you can use on this product.'
};
const translationsNamespace = exports.translationsNamespace = 'loyalty-dialog';
